import { safeDefine } from "../../registration/safe-define.js";
import { VolumeIndicatorFillElement } from "../../ui/volume-indicator/fill.js";
//#region src/define/ui/volume-indicator-fill.ts
safeDefine(VolumeIndicatorFillElement);
//#endregion

//# sourceMappingURL=volume-indicator-fill.js.map